export default class FolderBrowserDialogController {
    /** @ngInject */
    constructor(DialogService, folderChangedCallback) {
        this.DialogService = DialogService;
        this.folderChangedCallback = folderChangedCallback;
    }

    onFolderChange({ folderId, dblClicked }) {
        this.folderId = folderId;
        if (dblClicked) {
            this.submit();
        }
    }

    submit() {
        if (this.folderId) {
            this.folderChangedCallback(this.folderId);
        }
        this.DialogService.hide();
    }

    close() {
        this.DialogService.cancel();
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/popups/folder-browser/controller.js